export const getJavaScriptTemplate = (
  publisherId: string,
  publisherName: string,
  config: any
) => {
  const date = new Date().toISOString().split('T')[0];
  
  // Extract config values
  const placementMode = config.mode || 'after';
  const hasInlineConfig = placementMode === 'inline' && config.inline_config;
  
  // Generate inline config if needed
  let inlineConfigCode = '';
  if (hasInlineConfig) {
    const inlineConfig = config.inline_config;
    inlineConfigCode = `
  inlineConfig: {
    maxInsertions: ${inlineConfig.max_insertions || 1},
    insertionStrategy: "${inlineConfig.insertion_strategy || 'discourse'}",
    blendStyle: "${inlineConfig.blending_style === 'conversational' ? 'soft' : 
                  inlineConfig.blending_style === 'distinct' ? 'direct' : 'soft'}",
    insertAfterParagraphs: ${inlineConfig.insert_after_paragraphs || 1},${inlineConfig.tone_matching ? '\n    toneMatching: true,' : ''}${inlineConfig.skip_on_factual ? '\n    skipOnFactual: true,' : ''}
  }`;
  }
  
  // Generate response format preference if specified
  const responseFormatCode = config.response_format && config.response_format !== 'auto' 
    ? `\n  responseFormatPreference: "${config.response_format === 'text' ? 'plain' : config.response_format}",` 
    : '';

  return `// Generated configuration for publisher: ${publisherName}
// Publisher ID: ${publisherId}
// Generated on: ${date}

const { adServingMiddleware } = require('llm-ads-node');

// Your configuration based on selected settings
const config = {
  publisherId: "${publisherId}",  // Your Reasonic Publisher ID
  adPlacementMode: "${placementMode}",${responseFormatCode}${hasInlineConfig ? inlineConfigCode : ''}
};

// Implementation example for Express.js:
const express = require('express');
const app = express();

// Apply middleware
app.use(adServingMiddleware(config));

// Your routes
app.post('/api/llm', async (req, res) => {
  // Process LLM request
  // Ads will be automatically inserted based on your configuration
});

app.listen(3000, () => {
  console.log('Server running on port 3000');
});
`;
}; 